import { createRequire } from "module";
import { buildOneBabelPlugins } from "../babel-preset";
import { buildOneMetroResolverOverrides } from "./buildOneMetroResolverOverrides";
function getViteMetroPluginOptions(param) {
  var { projectRoot, relativeRouterRoot, ignoredRouteFiles, linking, userDefaultConfigOverrides, setupFile } = param;
  var require2 = createRequire(projectRoot + "/");
  try {
    require2.resolve("babel-preset-expo");
  } catch (unused) {
    throw new Error(`[one] Metro requires babel-preset-expo in the app at ${projectRoot}. Install it with your package manager, or remove native.bundler: 'metro' to use One's default native bundler.`);
  }
  var applyOneResolverOverrides = buildOneMetroResolverOverrides({
    projectRoot
  });
  return {
    oneViteMetroBabelConfig: true,
    defaultConfigOverrides: function defaultConfigOverrides(defaultConfig) {
      var config = applyOneResolverOverrides(defaultConfig);
      if (typeof userDefaultConfigOverrides === "function") {
        config = userDefaultConfigOverrides(config);
      }
      return config;
    },
    babelConfig: {
      plugins: buildOneBabelPlugins({
        projectRoot,
        relativeRouterRoot,
        ignoredRouteFiles,
        linking,
        setupFile,
        // vite path injects import-meta-env-plugin separately via the
        // metro server transformFile hook using the user's vite `define`.
        includeImportMetaEnv: false
      })
    }
  };
}
export {
  getViteMetroPluginOptions
};
//# sourceMappingURL=getViteMetroPluginOptions.js.map
